var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-timeline-item",class:[_vm.type, _vm.isFullWidth && 'is-full-width']},[_c('header',{staticClass:"ui-timeline-item_header"},[_vm._t("header")],2),_c('main',{staticClass:"ui-timeline-item_main"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }